export default function (theme) {
    return {
        MuiFab: {
            secondary: {
                backgroundColor: theme.palette.secondary.dark,
                color: theme.palette.secondary.contrastText,
            },
            label: {
                width: 'auto'
            },
            extended: {
                minWidth: 160,
                backgroundColor: theme.palette.secondary.dark,
                color: theme.palette.secondary.contrastText,
                '&:hover': {
                    backgroundColor: theme.palette.secondary.dark,
                    color: theme.palette.secondary.contrastText,
                }
            }
        }
    };
}